import React from 'react';

interface PromotionCardProps {
  title: string;
  count: number;
  icon: React.ElementType;
  backgroundColor?: string;
  borderColor?: string;
}

const PromotionCard: React.FC<PromotionCardProps> = ({
  title,
  count,
  icon: Icon,
  backgroundColor = '#ffffff',
  borderColor = '#E3F2FD'
}) => {
  return (
    <div
      className="p-3 p-sm-4 p-md-5 p-lg-6 rounded-lg shadow-md d-flex align-items-center justify-content-between"
      style={{
        backgroundColor,
        border: `1px solid ${borderColor}`
      }}
    >
      <div>
        <h3 className="fw-bold fs-5 fs-sm-4 mb-0 text-dark">{count}</h3>
        <p className="fs-8 fs-sm-7 mb-0 mt-2">{title}</p>
      </div>
      <div>
        <Icon size={24} className="d-sm-none" />
        <Icon size={32} className="d-none d-sm-block d-md-none" />
        <Icon size={36} className="d-none d-md-block d-lg-none" />
        <Icon size={40} className="d-none d-lg-block" />
      </div>
    </div>
  );
};

export default PromotionCard;
